import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from "redux-form";
import {renderTextField} from "./inputs/TextFeaild";
import {withStyles} from "material-ui";

export class PostForm extends React.Component {

    render() {

        const {handleSubmit, errors, classes} = this.props;

        return (
            <form onSubmit={handleSubmit}>

                <Field
                    className={classes.message}
                    name="comment"
                    multiline
                    rows={3}
                    rowsMax={5}
                    err={errors.comment}
                    component={renderTextField}
                    type="text"
                    placeholder="メッセージを入力"/>

            </form>
        )
    }
}

PostForm = withStyles((theme) => ({
    message: {
        background: '#f3f3f3',
        borderRadius: 5,
        padding: theme.spacing.unit,
        marginTop: -theme.spacing.unit * 3,
    }
}))(PostForm);

PostForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
};

PostForm = reduxForm({
    form: 'post'
})(PostForm);


// WEBPACK FOOTER //
// ./src/forms/post.js